<app-portal-collapsible
    [title]="insurant | fullName"
    [subtitle]="insurant.isInsuree ? 'Versicherungsnehmer' : 'Versicherte Person'"
    icon="person"
>
    <dl class="grid-container">
        <app-portal-widget-details
            class="g-12"
            heading="Geburtsdatum"
            [detail]="insurant.dateOfBirth"
        ></app-portal-widget-details>
    </dl>
</app-portal-collapsible>
